import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import 'normalize.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 全局mixin，所有组件都能直接用usr
Vue.mixin({
  computed: {
    usr() {
      return window.usr || {};
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
